import axiosInstance from "@/axios/axiosInstance";
import { IApiError } from "@/interface/apiError.types";
import {
  LoginCredentials,
  SendSignupLinkRequest,
  SendSignupLinkResponse,
  CompleteSignupRequest,
  CompleteSignupResponse,
  SendLoginLinkRequest,
  SendLoginLinkResponse,
  LogoutResponse,
  ValidateLinkResponse,
  ResetPasswordRequest,
  ResetPasswordResponse,
  Verify2FARequest,
  Verify2FAResponse,
  Resend2FARequest,
  Resend2FAResponse,
} from "@/interface/auth.types";
import { parseApiError } from "@/lib/error-parser";

export const loginUser = async (data: LoginCredentials) => {
  try {
    const response = await axiosInstance.post(`/auth/login`, data);
    return response?.data;
  } catch (error) {
    parseApiError(error as IApiError);
    throw error;
  }
};

// Signup methods
export const sendSignupLink = async (
  data: SendSignupLinkRequest
): Promise<SendSignupLinkResponse> => {
  try {
    const response = await axiosInstance.post(`/auth/send-signup-link`, data);
    return response?.data;
  } catch (error) {
    parseApiError(error as IApiError);
    throw error;
  }
};

export const completeSignup = async (
  uuid: string,
  data: CompleteSignupRequest
): Promise<CompleteSignupResponse> => {
  try {
    const response = await axiosInstance.post(`/auth/${uuid}/signup`, data);
    return response?.data;
  } catch (error) {
    parseApiError(error as IApiError);
    throw error;
  }
};

// Validate signup link
export const validateSignupLink = async (
  uuid: string
): Promise<ValidateLinkResponse> => {
  try {
    const response = await axiosInstance.post(`/auth/validate-link`, { uuid });
    return response?.data;
  } catch (error) {
    parseApiError(error as IApiError);
    throw error;
  }
};

// Magic link (login link) methods
export const sendLoginLink = async (
  data: SendLoginLinkRequest
): Promise<SendLoginLinkResponse> => {
  try {
    const response = await axiosInstance.post(`/auth/send-login-link`, data);
    return response?.data;
  } catch (error) {
    const errors = await parseApiError(error as IApiError);
    throw errors.error[0];
  }
};

// Logout method
export const logoutUser = async (): Promise<LogoutResponse> => {
  try {
    const response = await axiosInstance.post(`/auth/logout`);
    return response?.data;
  } catch (error) {
    throw error;
  }
};

//Forgot password

export const sendResetLink = async (
  payload: SendLoginLinkRequest
): Promise<SendLoginLinkResponse> => {
  try {
    const response = await axiosInstance.post(`/auth/forgot-password`, payload);
    return response?.data;
  } catch (error) {
    parseApiError(error as IApiError);
    throw error;
  }
};

// Reset password
export const resetPassword = async (
  data: ResetPasswordRequest
): Promise<ResetPasswordResponse> => {
  try {
    const response = await axiosInstance.post(`/auth/reset-password`, data);
    return response?.data;
  } catch (error) {
    parseApiError(error as IApiError);
    throw error;
  }
};

// 2FA methods
export const verify2FA = async (
  data: Verify2FARequest
): Promise<Verify2FAResponse> => {
  try {
    const response = await axiosInstance.post(`/auth/2fa/verify-code`, data);
    return response?.data;
  } catch (error) {
    parseApiError(error as IApiError);
    throw error;
  }
};

export const resend2FA = async (
  data: Resend2FARequest
): Promise<Resend2FAResponse> => {
  try {
    const response = await axiosInstance.post(`/auth/2fa/resend-code`, data);
    return response?.data;
  } catch (error) {
    parseApiError(error as IApiError);
    throw error;
  }
};
